import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../../annotation-handler';

@Component({
    selector: 'app-annotation-points',
    templateUrl: './annotation-points.component.html',
    styleUrls: ['./annotation-points.component.scss'],
    standalone: false
})
export class AnnotationPointsComponent {
  @Input() curAnn: AnnotationHandler;
  @Input() isDialog: boolean;
}
